import { Component, ContentChild, OnInit, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-vis-grid-column-header',
  templateUrl: './vis-grid-column-header.component.html',
  styleUrls: ['./vis-grid-column-header.component.css']
})
export class VisGridColumnHeaderComponent implements OnInit {

  @ViewChild(TemplateRef)
  templateRef : TemplateRef<any>;
  constructor() { }

  ngOnInit(): void {
  }

}
